import React from 'react'
import CMPService from '../../cmp/CMPService'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import lock from '../../genericComponents/assets/lock.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import s from './FooterPrivacy.less'

export default withEmptyFallbackErrorBoundary(function FooterPrivacy() {
  return (
    <div id="FooterPrivacy" className={s.FooterPrivacy} onClick={() => CMPService.open()}>
      <SVGIcon url={lock} />
      <T id={'footer.privacy'} />
    </div>
  )
})
